import { TableCell } from '@mui/material'
import React from 'react'

export const SettingsTableHeadCell = (p: any) => {
    return (
        <TableCell>
            <strong>{p.children}</strong>
        </TableCell>
    )
}